// extracted by mini-css-extract-plugin
export default {"wrapper":"gB-z","addressLine":"hB-z","fullName":"iB-z"};